import React from 'react';
import { createRoot } from 'react-dom/client';
import Application from './Application';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Application />);